import React from "react";

export default function MAIN_Content() {
  return (
    <div>
      <h1>Aquí va el contenido</h1>
      <p>Este será el área donde se renderizarán los módulos.</p>
    </div>
  );
}